// extracted by mini-css-extract-plugin
module.exports = {"massage_textarea":"MassageForm_massage_textarea__30iu8"};